import { Component, OnInit } from '@angular/core';
import { HelpNavigationService } from '../services/help-navigation.service';

@Component({
  selector: 'app-help.submission-history',
  imports: [],
  templateUrl: './help.submission-history.component.html',
  styleUrl: './help.submission-history.component.scss'
})
export class HelpSubmissionHistoryComponent implements OnInit {

  selectedSection = 'submissionhistorysdata';

  constructor(
    private navigationService: HelpNavigationService
  ) { }

  ngOnInit(): void {
    this.navigationService.selectedSection.next('submissionhistorysdata');
    this.navigationService.selectedSection.subscribe(section => {

      this.selectedSection = section;

      const element = document.getElementById(section);

      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }

    });

  }

  changeSection(section: string): void {

    this.selectedSection = section;

    const element = document.getElementById(section);

    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }

    this.navigationService.selectedSection.next(section);

  }

}
